<template>
  <div id="login">
    <div class="login-background"></div>
    <img src="/img/white-logo.svg" alt="Logo TimeSheet" class="login-image">
    <div>
      <div class="login-card">
        <img src="/img/white-meta.svg" class="meta-image" alt="Logo Meta">
        <form @submit.prevent="signIn">
          <div class="welcome">
            <h2 class="title">Bem-vindo!</h2>
            <h2>Faça seu login.</h2>
          </div>

          <!-- Início Formulário -->
          <input 
            type="text" 
            class="form-control" 
            placeholder="Digite seu usuário ou e-mail" 
            v-model="form.username" 
            autofocus
          >
          <input 
            :type="showPassword ? 'text' : 'password'"
            class="form-control" 
            placeholder="Digite sua senha" 
            v-model="form.password"
          >
          <!-- Exibir senha -->
          <i 
            v-if="!showPassword" 
            v-on:click="toggleShowPassword()" 
            class="fa fa-eye show-password"
          ></i>
          <i 
            v-if="showPassword" 
            v-on:click="toggleShowPassword()" 
            class="fa fa-eye-slash show-password" 
          ></i>

          <div class="remeber-password">
            <div class="form-check">
              <input 
                type="checkbox" 
                class="form-check-input" 
                id="remeber-password" 
                v-model="form.rememberPassword"
              >
              <label 
                class="form-check-label" 
                for="remeber-password"
              >Lembrar minha senha</label>
            </div>
          </div>
          
          <!-- Fim Formulário -->

          <button class="btn btn-secondary form-control">Entrar</button>
        </form>
      </div>
      <notifications group="login"/> 
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "./Login.scss";
</style>

<script>
import Uteis from '../../mixins/utils.js';

export default {
  mixins: [
    Uteis,
  ],

  data() {
    return {
      form: {
        username: '',
        password: '',
        rememberPassword: false,
      },
      showPassword: false,
    };
  },

  mounted() {
    const rememberPassword = JSON.parse(localStorage.getItem('rememberPassword') || 'false');

    if (rememberPassword) {
      this.form = JSON.parse(localStorage.getItem('rememberUser') || '{}');
    }
  },

  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },

    async signIn() {
      if (!this.isValidForm()) {
        return this.notificar('Preencha seu login e senha e tente novamente.',  'login');
      }

      await this.signInPromisse();
    },

    async signInPromisse() {
      try {
        this.$events.$emit('loading', true);

        const { username, password } = this.form;
        const { data: response } = await this.$http.post('/login', { 
          username, password: password.replace('@meta.com.br', '') 
        });

        this.signInCallback(response);
      } catch(e) {
        console.log(e);
        this.notificar('Ocorreu um erro. Entre em contato com o administrado do sistema.', 'login', 'dang');
      } finally {
        this.$events.$emit('loading', false);
      }
    },

    signInCallback(response) {
      if (!response.access_token) {
        return this.notificar('Usuário ou senha inválidos!', 'login');
      }

      this.$localStorage.set('user', JSON.stringify(response));
      this.setPermissions(response.perfis);
      this.rememberPassword();

      this.$router.push({ path: '/' });
    },

    rememberPassword() {
      localStorage.setItem('rememberPassword', this.form.rememberPassword);

      if (this.form.rememberPassword) {
        return localStorage.setItem('rememberUser', JSON.stringify(this.form));
      }

      return localStorage.removeItem('rememberUser');
    },

    setPermissions(permissoes) {
      if (_.filter(permissoes, { perfil_id: 1 }).length) {
        this.$acl.change('usuario');
      }
      if (_.filter(permissoes, { perfil_id: 2 }).length) {
        this.$acl.change('gestor');
      }
      if (_.filter(permissoes, { perfil_id: 3 }).length) {
        this.$acl.change('admin');
      }
    },

    isValidForm() {
      return !!this.form.username && !!this.form.password;
    },
  },
}
</script>
